




















































import { defineComponent } from '@vue/composition-api';
import AppButton from '@berlin-front/common/components/elements/AppButton';
import AppCard from '@berlin-front/common/components/elements/AppCard';
import AppContainer from '@berlin-front/common/components/elements/AppContainer';
import AttributeList from '@berlin-front/common/components/elements/AttributeList';
import AttributeName from '@berlin-front/common/components/elements/AttributeName';
import AttributeValue from '@berlin-front/common/components/elements/AttributeValue';
import AppProgressBar from '@berlin-front/common/components/elements/AppProgressBar';
import AppRow from '@berlin-front/common/components/elements/AppRow';
import AppText from '@berlin-front/common/components/elements/AppText';
import ModalHeader from '@berlin-front/common/components/clusters/ModalHeader';
import { useContext } from '@berlin-front/common/composables/context';
import { ModalHeaderContext } from '@services/ModalHeaderContext';
import { LINE_HEIGHT, TEXT_WEIGHT } from '@berlin-front/common/components/elements/AppText/composable';
import { HEIGHT_TYPE } from '@berlin-front/common/components/elements/AppProgressBar/composable';
import { formatTelNumber } from '@berlin-front/common/utils';
import { ConfirmMemberContext } from './composable';

export default defineComponent({
  name: 'ConfirmMemberView',
  components: {
    AppButton,
    AppCard,
    AppContainer,
    AppProgressBar,
    AppRow,
    AppText,
    AttributeList,
    AttributeName,
    AttributeValue,
    ModalHeader,
    HeaderContextConsumer: ModalHeaderContext.consumer,
  },

  setup() {
    const { useMemberConfirm } = useContext(ConfirmMemberContext);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    const { member, disabled, onClickSendSmsCode, progress, onClickBack } = useMemberConfirm();

    return {
      formatTelNumber,
      onClickBack,
      member,
      progress,
      progressHeightSize: HEIGHT_TYPE.SMALL,
      onClickSendSmsCode,
      disabled,
      text: {
        height: {
          height150: LINE_HEIGHT.HEIGHT150,
        },

        weight: {
          bold: TEXT_WEIGHT.WEIGHT700,
        },
      },
    };
  },
});
